import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import { Component } from 'react';
import { jsx } from '@emotion/react';
import { defineMessages, injectIntl } from 'react-intl-next';
import { TableSortOrder as SortOrder } from '@atlaskit/adf-schema/steps';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { addColumnAfter, addRowAfter, backspace, tooltip } from '@atlaskit/editor-common/keymaps';
import { DropdownMenuSharedCssClassName } from '@atlaskit/editor-common/styles';
import { backgroundPaletteTooltipMessages, cellBackgroundColorPalette, ColorPalette } from '@atlaskit/editor-common/ui-color';
import { ArrowKeyNavigationType, DropdownMenu } from '@atlaskit/editor-common/ui-menu';
import { closestElement } from '@atlaskit/editor-common/utils';
import { hexToEditorBackgroundPaletteColor } from '@atlaskit/editor-palette';
import { shortcutStyle } from '@atlaskit/editor-shared-styles/shortcut';
import { splitCell } from '@atlaskit/editor-tables/utils';
import { clearHoverSelection, hoverColumns, hoverMergedCells, hoverRows, toggleContextualMenu } from '../../commands';
import { deleteColumnsWithAnalytics, deleteRowsWithAnalytics, distributeColumnsWidthsWithAnalytics, emptyMultipleCellsWithAnalytics, insertColumnWithAnalytics, insertRowWithAnalytics, mergeCellsWithAnalytics, setColorWithAnalytics, sortColumnWithAnalytics, splitCellWithAnalytics } from '../../commands-with-analytics';
import { getPluginState } from '../../pm-plugins/plugin-factory';
import { getNewResizeStateFromSelectedColumns } from '../../pm-plugins/table-resizing/utils/resize-state';
import { canMergeCells } from '../../transforms';
import { TableCssClassName as ClassName } from '../../types';
import { getMergedCellsPositions, getSelectedColumnIndexes, getSelectedRowIndexes } from '../../utils';
import { contextualMenuDropdownWidth } from '../consts';
import tableMessages from '../messages';
import { cellColourPreviewStyles } from './styles';
export var messages = defineMessages({
  cellBackground: {
    id: 'fabric.editor.cellBackground',
    defaultMessage: 'Cell background',
    description: 'Change the background color of a table cell.'
  },
  mergeCells: {
    id: 'fabric.editor.mergeCells',
    defaultMessage: 'Merge cells',
    description: 'Merge tables cells together.'
  },
  splitCell: {
    id: 'fabric.editor.splitCell',
    defaultMessage: 'Split cell',
    description: 'Split a merged table cell.'
  },
  clearCells: {
    id: 'fabric.editor.clearCells',
    defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
    description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
  },
  sortColumnASC: {
    id: 'fabric.editor.sortColumnASC',
    defaultMessage: 'Sort column A → Z',
    description: 'Sort column in ascending order'
  },
  sortColumnDESC: {
    id: 'fabric.editor.sortColumnDESC',
    defaultMessage: 'Sort column Z → A',
    description: 'Sort column in descending order'
  },
  canNotSortTable: {
    id: 'fabric.editor.canNotSortTable',
    defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells",
    description: "Split your cells to enable this feature"
  },
  distributeColumns: {
    id: 'fabric.editor.distributeColumns',
    defaultMessage: "Distribute columns",
    description: "Distribute widths between selected columns"
  }
});
export var ContextualMenu = /*#__PURE__*/function (_Component) {
  _inherits(ContextualMenu, _Component);
  var _super = _createSuper(ContextualMenu);
  function ContextualMenu() {
    var _this;
    _classCallCheck(this, ContextualMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isSubmenuOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubMenuRef", function (ref) {
      var parent = closestElement(_this.props.editorView.dom, '.fabric-editor-popup-scroll-parent');
      if (!(parent && ref)) {
        return;
      }
      var boundariesRect = parent.getBoundingClientRect();
      var rect = ref.getBoundingClientRect();
      if (rect.left + rect.width > boundariesRect.width) {
        ref.style.left = "-".concat(rect.width, "px");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "createItems", function () {
      var _this$props = _this.props,
        allowMergeCells = _this$props.allowMergeCells,
        allowColumnSorting = _this$props.allowColumnSorting,
        allowBackgroundColor = _this$props.allowBackgroundColor,
        state = _this$props.editorView.state,
        isOpen = _this$props.isOpen,
        selectionRect = _this$props.selectionRect,
        formatMessage = _this$props.intl.formatMessage,
        editorView = _this$props.editorView,
        getEditorFeatureFlags = _this$props.getEditorFeatureFlags;
      var items = [];
      var isSubmenuOpen = _this.state.isSubmenuOpen;
      var _getEditorFeatureFlag = getEditorFeatureFlags(),
        useSomewhatSemanticTextColorNames = _getEditorFeatureFlag.useSomewhatSemanticTextColorNames;
      // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
      var _getPluginState = getPluginState(editorView.state),
        targetCellPosition = _getPluginState.targetCellPosition,
        allowDistributeColumns = _getPluginState.pluginConfig.allowDistributeColumns;
      if (allowBackgroundColor) {
        var _node$attrs;
        var node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        var background = hexToEditorBackgroundPaletteColor((node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.background) || '#ffffff');
        items.push({
          content: formatMessage(messages.cellBackground),
          value: {
            name: 'background'
          },
          elemAfter: jsx("div", {
            className: DropdownMenuSharedCssClassName.SUBMENU
          }, jsx("div", {
            css: cellColourPreviewStyles(background),
            className: ClassName.CONTEXTUAL_MENU_ICON
          }), isSubmenuOpen && jsx("div", {
            className: ClassName.CONTEXTUAL_SUBMENU,
            ref: _this.handleSubMenuRef
          }, jsx(ColorPalette, {
            cols: 7,
            onClick: _this.setColor,
            selectedColor: background,
            paletteOptions: {
              palette: cellBackgroundColorPalette,
              paletteColorTooltipMessages: backgroundPaletteTooltipMessages,
              hexToPaletteColor: hexToEditorBackgroundPaletteColor,
              // We did not want to create new FF or update
              //  useSomewhatSemanticTextColorNames name
              //  because it is temporary and require extra work.
              // So even though it says text color names,
              //  we are going to use for all color pickers
              //  such as text, background and table charts.
              showSomewhatSemanticTooltips: useSomewhatSemanticTextColorNames
            }
          })))
        });
      }
      items.push({
        content: formatMessage(tableMessages.insertColumn),
        value: {
          name: 'insert_column'
        },
        elemAfter: jsx("div", {
          css: shortcutStyle
        }, tooltip(addColumnAfter))
      });
      items.push({
        content: formatMessage(tableMessages.insertRow),
        value: {
          name: 'insert_row'
        },
        elemAfter: jsx("div", {
          css: shortcutStyle
        }, tooltip(addRowAfter))
      });
      var top = selectionRect.top,
        bottom = selectionRect.bottom,
        right = selectionRect.right,
        left = selectionRect.left;
      var noOfColumns = right - left;
      var noOfRows = bottom - top;
      items.push({
        content: formatMessage(tableMessages.removeColumns, {
          0: noOfColumns
        }),
        value: {
          name: 'delete_column'
        }
      });
      items.push({
        content: formatMessage(tableMessages.removeRows, {
          0: noOfRows
        }),
        value: {
          name: 'delete_row'
        }
      });
      if (allowMergeCells) {
        items.push({
          content: formatMessage(messages.mergeCells),
          value: {
            name: 'merge'
          },
          isDisabled: !canMergeCells(state.tr)
        });
        items.push({
          content: formatMessage(messages.splitCell),
          value: {
            name: 'split'
          },
          isDisabled: !splitCell(state)
        });
      }
      if (allowDistributeColumns) {
        var _newResizeState$chang;
        var newResizeState = getNewResizeStateFromSelectedColumns(selectionRect, state, editorView.domAtPos.bind(editorView), _this.props.getEditorContainerWidth);
        var wouldChange = (_newResizeState$chang = newResizeState === null || newResizeState === void 0 ? void 0 : newResizeState.changed) !== null && _newResizeState$chang !== void 0 ? _newResizeState$chang : false;
        items.push({
          content: formatMessage(messages.distributeColumns),
          value: {
            name: 'distribute_columns'
          },
          isDisabled: !wouldChange
        });
      }
      if (allowColumnSorting) {
        var hasMergedCellsInTable = getMergedCellsPositions(state.tr).length > 0;
        var warning = hasMergedCellsInTable ? {
          tooltipDescription: formatMessage(messages.canNotSortTable),
          isDisabled: true
        } : {};
        items.push(_objectSpread({
          content: formatMessage(messages.sortColumnASC),
          value: {
            name: 'sort_column_asc'
          }
        }, warning));
        items.push(_objectSpread({
          content: formatMessage(messages.sortColumnDESC),
          value: {
            name: 'sort_column_desc'
          }
        }, warning));
      }
      items.push({
        content: formatMessage(messages.clearCells, {
          0: Math.max(noOfColumns, noOfRows)
        }),
        value: {
          name: 'clear'
        },
        elemAfter: jsx("div", {
          css: shortcutStyle
        }, tooltip(backspace))
      });
      return items.length ? [{
        items: items
      }] : null;
    });
    _defineProperty(_assertThisInitialized(_this), "onMenuItemActivated", function (_ref) {
      var item = _ref.item;
      var _this$props2 = _this.props,
        editorView = _this$props2.editorView,
        selectionRect = _this$props2.selectionRect,
        editorAnalyticsAPI = _this$props2.editorAnalyticsAPI,
        getEditorContainerWidth = _this$props2.getEditorContainerWidth;
      // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
      var state = editorView.state,
        dispatch = editorView.dispatch;
      var _getPluginState2 = getPluginState(state),
        targetCellPosition = _getPluginState2.targetCellPosition;
      switch (item.value.name) {
        case 'sort_column_desc':
          sortColumnWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, selectionRect.left, SortOrder.DESC)(state, dispatch);
          _this.toggleOpen();
          break;
        case 'sort_column_asc':
          sortColumnWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, selectionRect.left, SortOrder.ASC)(state, dispatch);
          _this.toggleOpen();
          break;
        case 'merge':
          mergeCellsWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU)(state, dispatch);
          _this.toggleOpen();
          break;
        case 'split':
          splitCellWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU)(state, dispatch);
          _this.toggleOpen();
          break;
        case 'distribute_columns':
          var newResizeStateWithAnalytics = getNewResizeStateFromSelectedColumns(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth);
          if (newResizeStateWithAnalytics) {
            distributeColumnsWidthsWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
            _this.toggleOpen();
          }
          break;
        case 'clear':
          emptyMultipleCellsWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, targetCellPosition)(state, dispatch);
          _this.toggleOpen();
          break;
        case 'insert_column':
          insertColumnWithAnalytics(getEditorContainerWidth, editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
          _this.toggleOpen();
          break;
        case 'insert_row':
          insertRowWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, {
            index: selectionRect.bottom,
            moveCursorToInsertedRow: true
          })(state, dispatch);
          _this.toggleOpen();
          break;
        case 'delete_column':
          deleteColumnsWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, selectionRect)(state, dispatch);
          _this.toggleOpen();
          break;
        case 'delete_row':
          var _getPluginState3 = getPluginState(state),
            isHeaderRowRequired = _getPluginState3.pluginConfig.isHeaderRowRequired;
          deleteRowsWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
          _this.toggleOpen();
          break;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      var _this$props3 = _this.props,
        isOpen = _this$props3.isOpen,
        _this$props3$editorVi = _this$props3.editorView,
        state = _this$props3$editorVi.state,
        dispatch = _this$props3$editorVi.dispatch;
      toggleContextualMenu()(state, dispatch);
      if (!isOpen) {
        _this.setState({
          isSubmenuOpen: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpenChange", function () {
      var _this$props$editorVie = _this.props.editorView,
        state = _this$props$editorVie.state,
        dispatch = _this$props$editorVie.dispatch;
      toggleContextualMenu()(state, dispatch);
      _this.setState({
        isSubmenuOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleItemMouseEnter", function (_ref2) {
      var item = _ref2.item;
      var _this$props4 = _this.props,
        _this$props4$editorVi = _this$props4.editorView,
        state = _this$props4$editorVi.state,
        dispatch = _this$props4$editorVi.dispatch,
        selectionRect = _this$props4.selectionRect;
      if (item.value.name === 'background') {
        if (!_this.state.isSubmenuOpen) {
          _this.setState({
            isSubmenuOpen: true
          });
        }
      }
      if (item.value.name === 'delete_column') {
        hoverColumns(getSelectedColumnIndexes(selectionRect), true)(state, dispatch);
      }
      if (item.value.name === 'delete_row') {
        hoverRows(getSelectedRowIndexes(selectionRect), true)(state, dispatch);
      }
      if (['sort_column_asc', 'sort_column_desc'].indexOf(item.value.name) > -1 && getMergedCellsPositions(state.tr).length !== 0) {
        hoverMergedCells()(state, dispatch);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleItemMouseLeave", function (_ref3) {
      var item = _ref3.item;
      var _this$props$editorVie2 = _this.props.editorView,
        state = _this$props$editorVie2.state,
        dispatch = _this$props$editorVie2.dispatch;
      if (item.value.name === 'background') {
        _this.closeSubmenu();
      }
      if (['sort_column_asc', 'sort_column_desc', 'delete_column', 'delete_row'].indexOf(item.value.name) > -1) {
        clearHoverSelection()(state, dispatch);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "closeSubmenu", function () {
      if (_this.state.isSubmenuOpen) {
        _this.setState({
          isSubmenuOpen: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setColor", function (color) {
      var _this$props5 = _this.props,
        editorView = _this$props5.editorView,
        editorAnalyticsAPI = _this$props5.editorAnalyticsAPI;
      // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
      var _getPluginState4 = getPluginState(editorView.state),
        targetCellPosition = _getPluginState4.targetCellPosition;
      var state = editorView.state,
        dispatch = editorView.dispatch;
      setColorWithAnalytics(editorAnalyticsAPI)(INPUT_METHOD.CONTEXT_MENU, color, targetCellPosition)(state, dispatch);
      _this.toggleOpen();
    });
    return _this;
  }
  _createClass(ContextualMenu, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        isOpen = _this$props6.isOpen,
        mountPoint = _this$props6.mountPoint,
        offset = _this$props6.offset,
        boundariesElement = _this$props6.boundariesElement;
      var items = this.createItems();
      if (!items) {
        return null;
      }
      return jsx("div", {
        "data-testid": "table-cell-contextual-menu",
        onMouseLeave: this.closeSubmenu
      }, jsx(DropdownMenu, {
        mountTo: mountPoint
        //This needs be removed when the a11y is completely handled
        //Disabling key navigation now as it works only partially
        ,
        arrowKeyNavigationProviderOptions: {
          type: ArrowKeyNavigationType.MENU,
          disableArrowKeyNavigation: true
        },
        items: items,
        isOpen: isOpen,
        onOpenChange: this.handleOpenChange,
        onItemActivated: this.onMenuItemActivated,
        onMouseEnter: this.handleItemMouseEnter,
        onMouseLeave: this.handleItemMouseLeave,
        fitHeight: 188,
        fitWidth: contextualMenuDropdownWidth,
        boundariesElement: boundariesElement,
        offset: offset
      }));
    }
  }]);
  return ContextualMenu;
}(Component);
_defineProperty(ContextualMenu, "defaultProps", {
  boundariesElement: typeof document !== 'undefined' ? document.body : undefined
});
export default injectIntl(ContextualMenu);